import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import Form from 'react-bootstrap/Form'
import {TextAlign} from 'TemplateEditor/Layout/Blocks/DefaultBlockConfig'

export function TextAlignInput(props: {
  value: TextAlign
  setFieldValue: (field: string, value: TextAlign) => void
  label: string
  name: string
}) {
  const {t} = useI18n()
  const {value, setFieldValue, name} = props

  const handleOnChange = (value: TextAlign) => {
    setFieldValue(name, value)
  }

  return (
    <Form.Group className="mb-3 pb-2">
      <Form.Label>{props.label}</Form.Label>
      <Form.Select
        onChange={(e) => {
          handleOnChange(e.target.value as TextAlign)
        }}
        className="form-control"
        value={value}
      >
        <option value="left">{t('templateEditor.alignLeft')}</option>
        <option value="center">{t('templateEditor.alignCenter')}</option>
        <option value="justify">{t('templateEditor.alignJustify')}</option>
        <option value="right">{t('templateEditor.alignRight')}</option>
      </Form.Select>
    </Form.Group>
  )
}
